import Guardian from "./Guardian";
import common from "../../common";

export default class GuardianWitch extends Guardian {
    constructor(golden = false) {
        super("guardian_witch", Guardian.TYPE_WITCH, golden);

        this.setIdleAnims(["idle1_witch"]);
        this.setAttackAnims(["attack_witch"]);
        this.setDamageAnims(["damage_witch"]);
        this.setDefeatAnims(["defeat_witch"]);
        this.setVictoryAnims(["victory_witch"]);
        this.setWeaponRevealAnims(["weapon_reveal_witch"]);

        this._attackSoundName = "sfx_guardian_spell_attack_00";
    }
}